<template>
  <div>
    <div>{{data.SerialType}}编码设置</div>
    <el-form ref="form" :model="data" label-width="90px" style="margin-top: 15px;">
      <el-form-item label="编码方式">
        <el-radio-group v-model="data.Mode">
          <el-radio :label="0">自动编码</el-radio>
          <el-radio :label="1">手工编码</el-radio>
          <el-radio :label="2">自动编码可修改</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="编码前缀">
        <div v-if="data.HasClass" style="margin-right: 10px;display: inline-block;">
          <el-checkbox v-model="data.UseClassCode" label="使用类别编号" v-if="data.SerialType!='销售订单'"></el-checkbox>
          <el-checkbox v-model="data.UseClassCode" label="使用客户编码" v-if="data.SerialType=='销售订单'"></el-checkbox>
        </div>
        <el-input style="width: 220px;" v-model="data.Prefix"></el-input>
      </el-form-item>
      <el-form-item label="日期标识">
        <el-checkbox style="margin-right: 10px;" v-model="data.DateYear" label="年"></el-checkbox>
        <el-select class="select" v-model="data.DateYearLength">
          <el-option label="2位" :value="2"></el-option>
          <el-option label="4位" :value="4"></el-option>
        </el-select>
        <el-checkbox v-model="data.DateMonth" label="月"></el-checkbox>
        <el-checkbox v-model="data.DateDay" label="日"></el-checkbox>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="流水号长度">
            <el-select v-model="data.SerialLength">
              <el-option v-for="i in 9" :key="i" :label="i+'位'" :value="i"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="起始值">
            <el-input-number :min="0" v-model="data.StartValue"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="分隔符">
        <el-radio-group v-model="data.Separator">
          <el-radio :label="''">无</el-radio>
          <el-radio :label="'-'">-</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-alert :title="'编码示例：'+Sample" type="success" :closable="false"></el-alert>
    </el-form>
    <div style="text-align: center;margin-top: 10px;">
      <el-button style="width: 80px;" type="primary" @click="save">保 存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      api: require("@/api/sy/serialCode").default,
      data: {
        SerialCodeId: 0,
        SerialLength: 1, //流水号长度 1-9位
        SerialType: "", //类型
        Sn: 0, //序号
        StartValue: 0, //起始值
        DateDay: false, //日期标识-日
        DateMonth: false, //日期标识-月
        DateYear: false, //日期标识-年
        DateYearLength: 2, //日期标识-年位数 2/4位
        Mode: 0, //编码方式 自动编码/手动编码/自动编码可修改
        HasClass: false,
        UseClassCode: false,
        Prefix: "", //前缀
        PrefixPart: "", //前缀部分
        Separator: "", //分割符 空或-
      },
      Sample: "",
    };
  },
  methods: {
    setData(data) {
      // console.log("setData", JSON.parse(JSON.stringify(data)));
      this.data = data;
      this.getSample();
    },
    getSample() {
      this.api.previewNo(this.data.SerialType).then((res) => {
        console.log("serialType", res);
        if (res.Code == 0) {
          this.Sample = res.Data.PreviewNo == null ? "" : res.Data.PreviewNo;
        } else {
          this.$message.warning("获取" + this.data.SerialType + "编号失败");
        }
      });
    },
    save() {
      this.api.save(this.data).then((res) => {
        this.getSample();
        var type = res.Code == 0 ? "success" : "error";
        this.$message({ message: res.Msg, type: type });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.select {
  width: 75px !important;
  margin-right: 30px;
}
</style>